import { gql } from "@apollo/client";

export const VERIFY_CUSTOM_DONATION = gql`
  mutation VerifyCustomDonation(
    $id: String!
    $approved: Boolean!
    $rejectionReason: String
  ) {
    verifyCustomDonation(
      id: $id
      approved: $approved
      rejectionReason: $rejectionReason
    ) {
      _id
      title
      status
      isVerified
      verifiedBy
      verifiedAt
      rejectionReason
      customPaymentLink
      donationType
      publishedAt
      updatedAt
    }
  }
`;
